export default __webpack_public_path__ + "static/media/closed-captioning.2fb1b319.svg";